module.exports = __webpack_public_path__ + "static/img/siege_tech.5e017ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/siege_tech.png
// module id = 5f13
// module chunks = 0